import { render, staticRenderFns } from "./CourseNavigation.vue?vue&type=template&id=0a4a9149&scoped=true"
import script from "./CourseNavigation.vue?vue&type=script&lang=js"
export * from "./CourseNavigation.vue?vue&type=script&lang=js"
import style0 from "./CourseNavigation.vue?vue&type=style&index=0&id=0a4a9149&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a9149",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4a9149')) {
      api.createRecord('0a4a9149', component.options)
    } else {
      api.reload('0a4a9149', component.options)
    }
    module.hot.accept("./CourseNavigation.vue?vue&type=template&id=0a4a9149&scoped=true", function () {
      api.rerender('0a4a9149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseNavigation.vue"
export default component.exports